<template>
    <v-dialog v-model="d" width="40%" persistent>
        <v-card>
            <v-card-title>All Repeats</v-card-title>
            <v-card-text>
                <v-data-table :headers="headers" :items="r" class="elevation-1 mt-5">
                    <template v-slot:item.originalBookingName="{item}">
                        {{item.originalBookingName}} <span v-if="item.description">({{item.description}})</span>
                    </template>
                    <template v-slot:item.nextDate="{item}">
                        {{item.nextDate | moment('DD/MM/YYYY')}}
                    </template>
                    <template v-slot:item.lastBooked="{item}">
                        {{item.lastBooked | moment('DD/MM/YYYY')}}
                    </template>
                    <template v-slot:item.period="{item}">
                        {{convertPeriod(item.period)}}
                    </template>
                    <template v-slot:item.actions="{item}">
                        <v-icon color="info" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                        <v-icon color="error" class="mr-2" @click="deleteItem(item)">mdi-delete</v-icon>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn text color="primary" @click="closeDialog">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    export default {
        name: "UpcomingRepeatsDialog",
        computed: {
            ...mapState("repeats", ["upcomingRepeatsDialog", "upcomingRepeats"]),
            d: {
                get() {
                    return this.upcomingRepeatsDialog;
                }
            },
            r: {
                get() {
                    return this.upcomingRepeats;
                }
            }
        },
        methods: {
            ...mapActions("repeats", ["setUpcomingRepeatsDialog", "setManageRepeatDialog", "setActiveRepeat", "setManageDeleteRepeatDialog", "setRepeats"]),
            async closeDialog() {
                await this.setUpcomingRepeatsDialog(false);
            },
            async editItem(item) {
                await this.setActiveRepeat(item);
                await this.setUpcomingRepeatsDialog(false);
                await this.setManageRepeatDialog(true);
            },
            async deleteItem(item) {
                await this.setActiveRepeat(item);
                await this.setManageDeleteRepeatDialog(true);
                await this.setRepeats();
            },
            convertPeriod(period) {
                switch (period) {
                    case 0:
                        return 'Daily';
                    case 1:
                        return 'Weekly';
                    case 2:
                        return 'Monthly';
                    case 3:
                        return 'Yearly';
                    default:
                        return 'Unknown';
                }
            }
        },
        data() {
            return {
                headers: [
                    { text: 'Name', value: 'originalBookingName' },
                    { text: 'Period', value: 'period' },
                    { text: 'Next Date', value: 'nextDate' },
                    { text: 'Last Booked', value: 'lastBooked' },
                    { text: 'Actions', value: 'actions', sortable: false }
                ]
            }
        }
    }
</script>

<style scoped>

</style>
